module.exports = __webpack_public_path__ + "img/1fad6.45db874.svg";